import "@hotwired/turbo-rails"
import "./controllers"

function handleToasts() {
  const noticies = document.querySelectorAll(".notice");

  noticies.forEach((notice) => {
    notice.classList.add("show");

    setTimeout(() => {
      notice.classList.remove("show");

      setTimeout(() => {
        notice.remove();
      }, 500);
    }, 5000);
  });
}

document.addEventListener("turbo:load", handleToasts);
document.addEventListener("DOMContentLoaded", handleToasts); // fallback if not using Turbo
